import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

export default function Orders({
  handleChangeOrderSelect,
  value,
  isRetweet = false,
}) {
  const classes = useStyles();
  return (
    <FormControl className={classes.formControl}>
      <InputLabel id="demo-simple-select-label">並び順</InputLabel>
      <Select
        value={value}
        onChange={(event) => {
          handleChangeOrderSelect(event.target.value);
        }}
      >
        {isRetweet && <MenuItem value="retweet">話題順</MenuItem>}
        <MenuItem value="desc">新しい順</MenuItem>
        <MenuItem value="asc">古い順</MenuItem>
      </Select>
    </FormControl>
  );
}
